import API from "@/api/API";

const state = {
  flags: {},
  loaded: false,
};

const getters = {
  featureFlag: (state) => (name) => state.flags[name] ?? false,
  featureFlagsLoaded: (state) => state.loaded,
};

const mutations = {
  setFeatureFlags(state, flagsArray) {
    const map = {};
    for (const { name, value } of flagsArray) {
      map[name] = value;
    }
    state.flags = map;
    state.loaded = true;
  },
};

const actions = {
  async fetchFeatureFlags({ commit }) {
    try {
      const response = await API.companies.getFeatureFlags();
      commit("setFeatureFlags", response.data);
    } catch (err) {
      console.error("Failed to fetch feature flags:", err);
    }
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
